<template>
	<div>
		<span>
			{{
				selectRandom([
					"The protocol is registered at: ",
					"The protocol is available via: ",
				]) +
					$tera.project.introprotocol 
			}}
		</span>
		<!-- <p v-html="forProtocol+$tera.project.introprotocol"></p> -->
		<p v-html="$tera.project.intro"></p>
	</div>
</template>
<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputIntroduction",
	mixins: [OutputMixin],
	data() {
		return {
			forProtocol: "The protocol is registered at: "
		}
	},
};
</script>
